"use client";

import React, { useMemo } from "react";
import { cn } from "utils/utils";
import { RelativeTime } from "modules/common/components/ui/RelativeTime";
import { useCardGridItemContext } from "./CardGridItemContext";

interface CardGridItemPostedTimeProps {
  className?: string;
}

export function CardGridItemPostedTime({
  className,
}: CardGridItemPostedTimeProps) {
  const { item } = useCardGridItemContext();

  return (
    <RelativeTime
      date={item.updatedAt}
      className={cn("block text-secondary text-xs", className)}
    />
  );
}
